import React, { Component } from 'react';
import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

/**
 * Bloquea el acceso a una ruta que requiere que la sesión tenga un
 * profesional vinculado (sessionStorage 'codigo_med', guardado en el login
 * solo cuando el usuario tiene professional.id). Si no está, no se
 * renderiza el contenido de la ruta y se muestra un modal explicando por
 * qué, sin opción de cerrarlo salvo saliendo de la ruta.
 */
class GuardProfesionalRegistrado extends Component {

  componentDidMount(){
    if(!sessionStorage.getItem('codigo_med')){
      $('#modal-profesional-no-registrado').modal('show');
    }
  }

  render(){
    const tieneProfesional = !!sessionStorage.getItem('codigo_med');

    return (
      <React.Fragment>

        {tieneProfesional ? this.props.children : null}

        <div className="modal fade" id="modal-profesional-no-registrado" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content cancelar-cita-modal">
              <div className="modal-header cancelar-cita-modal__header">
                <div className="cancelar-cita-modal__icono"><i className="fas fa-exclamation-triangle"></i></div>
                <h4 className="modal-title cancelar-cita-modal__title">Atención {(sessionStorage.getItem('nombre_usua')||'').trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</h4>
              </div>
              <div className="modal-body cancelar-cita-modal__body">
                <p className="cancelar-cita-modal__texto">
                  <b>Tu usuario no es profesional de la salud y por eso no puedes ver la agenda.</b>
                </p>
                <p className="cancelar-cita-modal__texto">
                  Esta vista solo se habilita a profesionales de la salud que tienen un convenio creado con este prestador. Regístrate en la App Medicall24 y luego crea tu convenio.
                </p>
                <p className="cancelar-cita-modal__texto">
                  Disponible en App Store y Play Store
                </p>
              </div>
              <div className="modal-footer justify-content-center cancelar-cita-modal__footer">
                <a href="/inicio_profesional" className="btn cancelar-cita-modal__btn-cancelar">Entendido</a>
              </div>
            </div>
          </div>
        </div>

      </React.Fragment>
    )
  }

}

export default GuardProfesionalRegistrado;
